export default "__VITE_ASSET__jcHuypSI__"